'use strict';

angular.module('licensure.services')
    .factory('LicenseChargeCalculatedFields', ['$http', '$q', function ($http, $q) {
        return {
            get: function (licenseID) {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/LicensingModule/LicenseChargeCalculatedFields', {
                        params: { licenseID: licenseID }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCalculatedValue: function (questionID, chargeValue, responseID) {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/LicensingModule/CalculatedValue', {
                        params: { questionID: questionID, chargeValue: chargeValue, responseID: responseID }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        }
    }])
;